function lhmToggleFaqs(questionClass) {
    const questions = document.querySelectorAll(questionClass);
    if (!questions.length) return;

    function toggleQuestion(question) {
        const answer = question.nextElementSibling;
        if (!answer) return;

        const isOpen = answer.classList.contains('opened');

        question.classList.toggle('active', !isOpen);
        question.setAttribute('aria-expanded', String(!isOpen));
        answer.classList.toggle('opened', !isOpen);
        answer.inert = isOpen;

        answer.style.maxHeight = !isOpen ? answer.scrollHeight + 'px' : '0';
    }

    questions.forEach(function (question) {
        question.addEventListener('click', function () {
            toggleQuestion(this);
        });

        question.addEventListener('keydown', function (e) {
            if (e.key !== 'Enter' && e.key !== ' ' && e.key !== 'Spacebar') return;

            e.preventDefault();
            toggleQuestion(this);
        });
    });
}

window.lhmToggleFaqs = lhmToggleFaqs;
